// @ts-strict-ignore
import { Container, Image } from '@components/gassan-ui'
import { Heading } from '@components/gassan-ui/Typography/Heading'
import { getKontentImage } from '@lib/kontent'
import * as Elements from '@lib/kontent/models/Elements'
import { FC, useEffect, useRef, useState } from 'react'
import { cn } from '@lib/cn'

type RichExperiencePageHeroProps = {
  title: string
  description: string
  desktopImage: Elements.AssetsElement
  mobileImage: Elements.AssetsElement
  handleImageLoaded: () => void
}

export const RichExperiencePageHero: FC<RichExperiencePageHeroProps> = ({
  title,
  description,
  desktopImage,
  mobileImage,
  handleImageLoaded,
}) => {
  const timer = useRef<NodeJS.Timer>()
  const [imageLoaded, setLoaded] = useState(false)

  useEffect(() => {
    clearTimeout(timer.current)
    timer.current = setTimeout(handleImageLoaded, 500)

    return () => {
      clearTimeout(timer.current)
    }
  }, []) // eslint-disable-line

  return (
    <section
      className={cn(
        'relative flex w-full translate-y-[-4px] items-center justify-start pt-[108%] opacity-0 transition-[opacity,transform]',
        'lg:pt-[34%]',
        imageLoaded ? 'translate-y-0 opacity-100' : '',
      )}
      style={{
        transitionDuration: '0.75s',
        transitionDelay: '0.2s',
      }}
      data-is-loaded={imageLoaded ? '' : undefined}
    >
      <span
        className={cn(
          'absolute bottom-0 left-0 z-[1] block h-[50%] w-full bg-[linear-gradient(359.73deg,#141414_4.22%,rgba(20,20,20,0)_103.75%)] opacity-50',
          'lg:h-full lg:w-[60%] lg:bg-[linear-gradient(90deg,rgba(20,20,20,0.7)_0%,rgba(20,20,20,0)_100%)]',
        )}
      />
      <Image
        objectFit="cover"
        className="absolute inset-0 z-0"
        onLoad={() => setLoaded(true)}
        sources={[
          getKontentImage(mobileImage.value[0].url, { width: 768 }),
          getKontentImage(mobileImage.value[0].url, { width: 1024 }),
          getKontentImage(desktopImage.value[0].url, { width: 1440 }),
          getKontentImage(desktopImage.value[0].url, { width: 1552 }),
          getKontentImage(desktopImage.value[0].url, { width: 1920 }),
          getKontentImage(desktopImage.value[0].url, { width: 2500 }),
        ]}
      />
      <div
        className={cn(
          'absolute bottom-[20px] left-[16px] right-[16px] z-[1] mx-auto flex h-fit',
          'lg:left-[24px] lg:right-[24px] lg:top-[50%] lg:translate-y-[-50%]',
          'xl:left-[44px] xl:right-[44px] xl:max-w-[1744px]',
        )}
      >
        <Container as="div" className="!ml-0 max-w-[650px]">
          <Heading variant="hXl" as="h1" className="mb-2 text-white">
            {title}
          </Heading>
          <Heading variant="h4" as="p" className="mb-0 text-white">
            {description}
          </Heading>
        </Container>
      </div>
    </section>
  )
}
